if (!customElements.get('fuyu-discount')) {
  customElements.define('fuyu-discount', class extends HTMLElement {
    connectedCallback() {
      this.querySelector('form').addEventListener('submit', async event => {
        event.preventDefault();
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        const code = this.querySelector('input').value.trim();
        if (!code) return;
        button.disabled = true;
        status.textContent = '';
        try {
          const drawer = this.closest('cart-drawer');
          const sectionIds = drawer ? drawer.getSectionsToRender().map(s => s.id) : ['main-cart-footer', 'cart-icon-bubble', 'main-cart-items'];
          const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST', headers: {'Content-Type':'application/json'},
            body: JSON.stringify({discount:code, sections:sectionIds, sections_url:window.location.pathname})
          });
          const cart = await response.json();
          if (!response.ok) throw new Error('cart');
          const applied = (cart.discount_codes || []).some(d => d.code.toLowerCase() === code.toLowerCase() && d.applicable);
          if (!applied) { status.textContent = this.dataset.error; return; }
          if (drawer) drawer.renderContents(cart); else window.location.reload();
        } catch { status.textContent = this.dataset.networkError; }
        finally { button.disabled = false; }
      });
    }
  });
}

if (!customElements.get('winter-sticky-buy')) {
  customElements.define('winter-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      const product = this.closest('product-info');
      const mainButton = product?.querySelector('product-form button[type="submit"]');
      if (!mainButton || this.closest('quick-add-modal')) return;
      const button = this.querySelector('button');
      button.addEventListener('click', () => {
        mainButton.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
        mainButton.focus({preventScroll:true});
      });
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      this.observer.observe(mainButton);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
